import React from "react";
import styled, { keyframes } from "styled-components";

interface Props {
  muted: boolean;
  onToggle: () => void;
  world: string;
}

const WORLD_COLORS: Record<string, string> = {
  doctorStrange: "#8b5cf6",
  harryPotter: "#ffd700",
  ben10: "#00cc00",
};

const MusicToggle: React.FC<Props> = ({ muted, onToggle, world }) => {
  const color = WORLD_COLORS[world] || "#8b5cf6";

  return (
    <ToggleBtn onClick={onToggle} $color={color} $playing={!muted} title={muted ? "Play music" : "Mute music"}>
      {muted ? (
        <MuteIcon>
          <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <polygon points="11 5 6 9 2 9 2 15 6 15 11 19 11 5" />
            <line x1="23" y1="9" x2="17" y2="15" />
            <line x1="17" y1="9" x2="23" y2="15" />
          </svg>
        </MuteIcon>
      ) : (
        <PlayingIcon $color={color}>
          <Bar $color={color} $delay="0s" />
          <Bar $color={color} $delay="0.15s" />
          <Bar $color={color} $delay="0.3s" />
          <Bar $color={color} $delay="0.1s" />
        </PlayingIcon>
      )}
    </ToggleBtn>
  );
};

export default MusicToggle;

const bounce = keyframes`
  0%, 100% { height: 3px; }
  50% { height: 12px; }
`;

const ToggleBtn = styled.button<{ $color: string; $playing: boolean }>`
  position: fixed;
  top: 70px;
  right: 1.5rem;
  z-index: 100;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  border-radius: 50%;
  border: 1px solid ${({ $color }) => $color}30;
  background: rgba(10, 8, 14, 0.7);
  backdrop-filter: blur(12px);
  cursor: pointer;
  transition: all 0.3s ease;
  padding: 0;

  &:hover {
    border-color: ${({ $color }) => $color}60;
    background: rgba(10, 8, 14, 0.9);
    transform: scale(1.1);
  }

  @media (max-width: 768px) {
    top: 65px;
    right: 0.8rem;
    width: 28px;
    height: 28px;
  }
`;

const MuteIcon = styled.span`
  display: flex;
  align-items: center;
  justify-content: center;
  opacity: 0.5;
`;

const PlayingIcon = styled.div<{ $color: string }>`
  display: flex;
  align-items: flex-end;
  gap: 2px;
  height: 14px;
`;

const Bar = styled.div<{ $color: string; $delay: string }>`
  width: 2px;
  height: 3px;
  background: ${({ $color }) => $color};
  border-radius: 1px;
  animation: ${bounce} 0.6s ease-in-out infinite;
  animation-delay: ${({ $delay }) => $delay};
`;
